import React from "react";

import { graphql } from "gatsby";

import Text from "cms/components/Text";
import SaaSWebAppImage from "cms/images/cloud-sharing-web-app-cover.png";
import iOSImage from "cms/images/ios15_cover.png";
import LandingPageImage from "cms/images/lando_cover.png";
import MobileWireframeImage from "cms/images/mobile_wireframe_cover.png";
import ProductivityAppImage from "cms/images/productivity_app_cover.png";
import WebsiteWireframeImage from "cms/images/web_wireframe_cover.png";

import {
  Container,
  Content,
  Illustration,
  IllustrationContainer,
  Link,
  TemplateSuggestion,
  TemplateSuggestionsContainer,
} from "./TemplateSuggestionsBlock.styles";

const TEMPLATES = [
  {
    image: LandingPageImage,
    imageAlt: "startup landing page Lando example project image",
    url: "https://uizard.io/templates/website-templates/startup-landing-page/",
    description: "A startup landing page",
  },
  {
    image: WebsiteWireframeImage,
    imageAlt: "Website wireframe example project image",
    url: "https://uizard.io/templates/website-templates/website-wireframe/",
    description: "A website wireframe",
  },
  {
    image: ProductivityAppImage,
    imageAlt: "Productiviy mobile app project image",
    url: "https://uizard.io/templates/mobile-app-templates/productivity-mobile-app/",
    description: "A productivity app",
  },
  {
    image: MobileWireframeImage,
    imageAlt: "Mobile wireframe example project image",
    url: "https://uizard.io/templates/mobile-app-templates/mobile-app-wireframe/",
    description: "A mobile app wireframe",
  },
  {
    image: iOSImage,
    imageAlt: "iOS 15 mobile app project image",
    url: "https://uizard.io/templates/mobile-app-templates/ios-mobile-app/",
    description: "An iOS mobile app",
  },
  {
    image: SaaSWebAppImage,
    imageAlt: "Cloud storage web app project image",
    url: "https://uizard.io/templates/web-app-templates/cloud-storage-web-app/",
    description: "A SaaS web app",
  },
] as const;

export interface TemplateSuggestionsBlockProps
  extends Queries.SanityTemplateSuggestionsBlock {}

const TemplateSuggestionsBlock: React.FC<TemplateSuggestionsBlockProps> = ({
  headline,
}) => (
  <Container>
    <Content>
      <Text variant="H3" as="h3" textAlign="center" marginBottom="1rem">
        {headline}
      </Text>
      <TemplateSuggestionsContainer>
        {TEMPLATES?.map((template) => (
          <Link href={template?.url || undefined} key={template.description}>
            {template?.image && template.url && (
              <TemplateSuggestion>
                <IllustrationContainer>
                  <Illustration src={template.image} alt={template.imageAlt} />
                </IllustrationContainer>
                <Text variant="B2" as="p" weight="medium" marginTop="0.5rem">
                  {template.description}
                </Text>
              </TemplateSuggestion>
            )}
          </Link>
        ))}
      </TemplateSuggestionsContainer>
    </Content>
  </Container>
);

export const query = graphql`
  fragment TemplateSuggestionsBlock on SanityTemplateSuggestionsBlock {
    _key
    _type
    headline
  }
`;

export default TemplateSuggestionsBlock;
